module.exports = __webpack_public_path__ + "img/expression4.ceaa5a23.png";